import React, { useEffect, useState } from "react";
import axiosInstance from "../../axios/axiosInstance";
import { toast } from "react-toastify";

const StreamVehicle = () => {
  const [vehicles, setVehicles] = useState<{ plate_no: string; date: string; label?: string; cam_id?: string; node?: string }[]>([]);
  const [screen, setScreen] = useState("recorded");
  const [allVehicle, setAllVehicle] = useState<any[]>([]);

  const handleChange = (newScreen: string) => {
    setScreen(newScreen);
  };

  const handleGetAll = async () => {
    try {
      const resp: any = await axiosInstance.get("/api/vehicle/list/vehicle");
      if (resp.status === 200) {
        setAllVehicle(resp?.data?.data);
      }
    } catch (Error: any) {
      toast.error(Error);
    }
  };

  useEffect(() => {
    handleGetAll();
    const socket = new WebSocket("ws://localhost:3070");
    socket.onopen = () => {
      // Connected
    };
    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setVehicles((prev) => [data, ...prev.slice(0, 9)]); // Keep only latest 10
    };
    socket.onclose = () => {};
    socket.onerror = () => {};
    return () => {
      socket.close();
    };
  }, []);

  return (
    <div className="p-4 md:px-12">
      <div className="mb-4 flex gap-2">
        <button
          className={`px-4 py-2 rounded-l bg-${screen === "recorded" ? "blue-600 text-white" : "gray-200 text-gray-700"} font-semibold focus:outline-none`}
          onClick={() => handleChange("recorded")}
        >
          Recorded
        </button>
        <button
          className={`px-4 py-2 rounded-r bg-${screen === "live" ? "blue-600 text-white" : "gray-200 text-gray-700"} font-semibold focus:outline-none`}
          onClick={() => handleChange("live")}
        >
          Live
        </button>
      </div>
      {screen === "live" && (
        <>
          <h2 className="text-xl font-bold text-gray-800 mb-4">Live Vehicles</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {vehicles.map((vehicle, index) => (
              <div key={index} className="bg-white rounded-lg shadow p-4 flex flex-col gap-2">
                <div className="text-lg font-semibold text-blue-700">{vehicle?.plate_no}</div>
                <div className="text-gray-500 text-sm">{new Date(vehicle.date).toLocaleString()}</div>
                {vehicle.label && <div className="text-gray-700 text-xs">Label: {vehicle.label}</div>}
                {vehicle.cam_id && <div className="text-gray-700 text-xs">Camera: {vehicle.cam_id}</div>}
                {vehicle.node && <div className="text-gray-700 text-xs">Node: {vehicle.node}</div>}
              </div>
            ))}
            {vehicles.length === 0 && <div className="col-span-full text-gray-400 text-center py-8">No live vehicles yet.</div>}
          </div>
        </>
      )}
      {screen === "recorded" && (
        <>
          <h2 className="text-xl font-bold text-gray-800 mb-4">List Vehicles</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {allVehicle.map((vehicle, index) => (
              <div key={index} className="bg-white rounded-lg shadow p-4 flex flex-col gap-2">
                <div className="text-lg font-semibold text-blue-700">{vehicle?.vehicle_no}</div>
                <div className="text-gray-500 text-sm">{new Date(vehicle.date).toLocaleString()}</div>
                {vehicle.label && <div className="text-gray-700 text-xs">Label: {vehicle.label}</div>}
                {vehicle.cam_id && <div className="text-gray-700 text-xs">Camera: {vehicle.cam_id}</div>}
                {vehicle.node && <div className="text-gray-700 text-xs">Node: {vehicle.node}</div>}
              </div>
            ))}
            {allVehicle.length === 0 && <div className="col-span-full text-gray-400 text-center py-8">No recorded vehicles found.</div>}
          </div>
        </>
      )}
    </div>
  );
};

export default StreamVehicle;
